import { resolveLocaleFromPathname } from '@/src/shared/lib/i18n/resolveLocaleFromPathname';
import { performClientLogout } from './performClientLogout';

// Single-flight guard: when several authed requests 401 at once, only the first
// runs the logout + redirect; the rest are no-ops.
let handlingUnauthorized = false;

export async function handleUnauthorized(): Promise<void> {
  if (typeof window === 'undefined') return;

  const locale = resolveLocaleFromPathname(window.location.pathname);
  const loginPath = `/${locale}/login`;

  // Already on the login page: a 401 here would otherwise loop back to it.
  if (window.location.pathname === loginPath) return;

  if (handlingUnauthorized) return;
  handlingUnauthorized = true;

  try {
    await performClientLogout();
  } finally {
    handlingUnauthorized = false;
  }
}
